export const AppConfiguration = {
  dateFormat: "M/D/YYYY",
  timeFormat: "h:mm A",
  fullDateFormat: "M/D/YYYY h:mm A",
  timeFormat24H: "HH:mm"
};
